import "./ToastForgotPassword.css";
import Button from "../../../components/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../components/modal/Modal";
import ButtonSecondary from "../../../components/buttonSecondary/ButtonSecondary";
import { useBrandContext } from "../../../context/BrandContext";
import { useEffect } from "react";

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  allowButtonClosed: boolean;
  handleForgotPassword: () => void;
  email: string;
  isLoading?: boolean;
  resendDisabled: boolean;
  setResendDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  secondsLeft: number;
  setSecondsLeft: React.Dispatch<React.SetStateAction<number>>;
}

const ToastForgotPassword: React.FC<Props> = ({
  isModalOpen,
  isLoading,
  setIsModalOpen,
  allowButtonClosed,
  handleForgotPassword,
  email,
  resendDisabled,
  setResendDisabled,
  secondsLeft,
  setSecondsLeft
}) => {
  
  
  const navigate = useNavigate();
  const location = useLocation();

  const brandContext = useBrandContext();
    // const routePaths = location.pathname.split('/');

  const backToLogin = () => {
    setIsModalOpen(false);
    navigate(`/${brandContext.brandName}/login`);
  }

  return (
    <>
      <Modal 
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        title="Esqueci a senha"
        onClose={() => setIsModalOpen(false)}
      >
        <p className="toast-forgot-password-modal-text">
            Enviamos um e-mail de alteração de senha para <b>{email ? email : "o seu e-mail"}</b>. 
            Caso não encontre, pode estar na sua caixa de spam.
        </p>
        <Button
          style={{backgroundColor: '#fff', color: '#787E7D', border: '1px solid #787E7D', cursor: resendDisabled ? 'not-allowed' : 'pointer', opacity: resendDisabled ? 0.5 : 1}}
          type= 'button'
          children = {resendDisabled ? `Aguarde ${secondsLeft}s...` : "Enviar novamente"}
          onClick= {() => {
            if (!resendDisabled) {
              handleForgotPassword();
              setResendDisabled(true);
            }
          }}
          disabled={resendDisabled}
          spinnerSecondary={true}       
          loading={isLoading}          

        />
        <ButtonSecondary
          style={{ color: '#2E373E'}}
          type= 'button'
          children = "Voltar ao login"
          onClick={backToLogin}
        />
      </Modal>
    </>
  );
};

export default ToastForgotPassword;
